<template>
  <div id="table_target">
    <table>
      <tr id="mainRow">
        <th v-for="header in headers" v-bind:key="header">
          {{ header }}
        </th>
      </tr>
      <tr v-for="row in tablepage" v-bind:key="row.id">
        <td>{{ row.name }}</td>
        <td>{{ row.address }}</td>
        <td>{{ row.place }}</td>
        <td>{{ row.state }}</td>
        <td>{{ row.type }}</td>
        <td>{{ row.products }}</td>
        <td>{{ row.services }}</td>
      </tr>
    </table>
    <div>
      <a v-for="page in paging" v-bind:key="page.label" href="#" :data-page="page.page" v-on:click="setpage($event)">{{ page.label }}</a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    setpage: function (event) {
      if (event) event.preventDefault()
      var newPage = event.currentTarget.getAttribute('data-page')
      this.$store.commit('SET_PAGE', newPage)
    }
  },
  data () {
    return {
      currentPage: 0,
      maxRows: 100,
      headers: ['name', 'address', 'place', 'state', 'type', 'products', 'services'],
      pagings: [1, '', 1, 2, ''],
      loadPaging: function () {
        this.paging = this.livepaging
      }
    }
  },
  computed: {
    tablepage () {
      return this.$store.getters.tablePage
    },
    paging () {
      return this.$store.getters.paging
    }
  }
}
</script>

<style>
  #table_target table {
    font-size: 12px;
    text-align: left;
    width: 100%;
  }
  #table_target table tr {
    border-bottom: 1px solid #2f6144;
  }
  #table_target table tr:hover {
    background-color: #869b92;
  }
  #table_target a {
    display: inline-block;
    margin-right: 10px;
    padding: 5px;
    background-color: #869b92;
  }
</style>



// WEBPACK FOOTER //
// src/components/table.vue